/* eslint-disable jsx-a11y/label-has-for */

/*
 * OkCupid Native Forms: they're like forms, but native.
 * this.namespace OKNF
 */

/*
 * Clickable. Radio, Select, and Switch are all parents
 * this.param [type] {String} gotta be one of "radio", "select", or "switch"
 * this.private
 */

import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import classnames from "classnames";

const Clickable = (props) => {
	const clickableClasses = {
		[`oknf-${props.type}`]: true,
		[`oknf-${props.type}--has-label`]: props.label,
		[`oknf-${props.type}--has-bg`]: props.hasBg,
		[`oknf-${props.type}--disabled`]: props.disabled,
	};

	if (props.className) {
		clickableClasses[props.className] = true;
	}

	let elementType = props.type;

	if (props.type === "switch") {
		elementType = "checkbox";
	}

	const clickableProps = {
		type: elementType,
		name: props.name,
		value: props.value,
		checked: props.checked,
		disabled: props.disabled,
		onChange: props.onChange,
		readOnly: props.readOnly,
	};

	if (props.id && props.id !== "") {
		clickableProps.id = props.id;
	}

	return (
		<label className={classnames(clickableClasses)}>
			<input {...clickableProps} />
			<span className={`oknf-${props.type}-decoration`} />
			{props.label &&
				<span className={`oknf-${props.type}-label`}>
					{props.label}
				</span>
			}
		</label>
	);
};

Clickable.propTypes = {
	type: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.bool,
	]),
	label: PropTypes.node,
	onChange: PropTypes.func,
	className: PropTypes.string,
	id: PropTypes.string,
	name: PropTypes.string,
	hasBg: PropTypes.bool,
	disabled: PropTypes.bool,
	checked: PropTypes.bool,
	readOnly: PropTypes.bool,
};

Clickable.defaultProps = {
	value: "",
	label: null,
	onChange: noop,
	className: null,
	id: null,
	name: null,
	hasBg: false,
	disabled: false,
	checked: false,
	readOnly: false,
};

export default Clickable;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/_Clickable.jsx